import type { MemberPosition } from "@69ly/shared";
import { useQuery } from "@tanstack/react-query";
import { api } from "./api.ts";

/** Who plays where in a team (Team › Who plays where): one query, shared by the Team page, the library and Live. */
export const positionsKey = (teamId: string) => ["teams", teamId, "positions"] as const;

export function usePositions(teamId: string | null) {
  return useQuery({ queryKey: positionsKey(teamId ?? ""), queryFn: () => api<MemberPosition[]>("GET", `/teams/${teamId}/positions`), enabled: !!teamId });
}
